module.exports = __webpack_public_path__ + "img/operations-center-connection.32fa5a9a.gif";